import { hotTopics } from '@/mocks/chaoyang';

export default function TopicSection() {
  return (
    <section id="rehua" className="w-full scroll-mt-20 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-col gap-2 text-center sm:items-center">
          <p className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-sm font-medium text-accent-800">
            <i className="ri-flashlight-fill"></i> 朝阳吃瓜头条 · 热议焦点
          </p>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">今日热门话题</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            从全民热议到朝阳吃瓜头条，编辑部精选值得围观的焦点，附上背后脉络，帮你快速吃透每一个瓜。
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {hotTopics.map((t) => (
            <article
              key={t.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:border-primary-200"
            >
              <a href="#guanyu" className="relative block aspect-[8/5] w-full overflow-hidden">
                <img
                  src={t.image}
                  alt={t.title}
                  title={`${t.title} · 朝阳吃瓜热议`}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${
                    t.hot ? 'bg-primary-500' : 'bg-accent-600'
                  }`}
                >
                  {t.tag}
                </span>
              </a>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <a href="#guanyu">
                  <h3 className="line-clamp-2 text-base font-semibold leading-snug text-foreground-950 transition group-hover:text-primary-700 md:text-lg">
                    {t.title}
                  </h3>
                </a>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{t.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-3">
                    <span><i className="ri-eye-line mr-1"></i>{t.reads}</span>
                    <span><i className="ri-chat-3-line mr-1"></i>{t.comments}</span>
                  </span>
                  <span className="whitespace-nowrap">{t.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}